export default __webpack_public_path__ + "static/media/Add.df227226.svg";